const texts = {
  errorAddingAssignment: 'Failed to add assignment. Error: {error}',
  errorLoadingUsers: 'Failed to load users. Error: {error}',
  errorCheckingPool: 'Failed to check pool membership. Error: {error}',
  notePlaceholder: 'Note (optional)',
  poolRemovalTitle: 'Remove {coach} from the coach pool?',
  poolRemovalDescription: '{coach} is currently in the coach pool. This assignment removes them from the pool — a '
    + 'coach is never both.',
};

export default texts;
